<template>
    <div id="home" class="backing">
        <v-app>
        <v-container fluid class="container_inner" fill-height>
            <v-row>
                <v-col cols="12">
            <Masthead/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
            <NavBar/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <div style="text-align: left">
                                <p>Here are family photos submitted by some of Dan's friends and family. Dan sure was a character, and that sure translates here even after all this time.
                                <p>Feel free to <a href="mailto:jim3@jimwcoleman.com?subject=Dan Schmidt photos">e-mail me</a> any additional photos you may wish to share. Thank you!</p>
                            </div>
                </v-col>
                <v-col cols="12" md="8">
                    <div>
                        <slot />
                    </div>
                </v-col>
            </v-row>

            <v-row justify="center">


            </v-row>
            <FooterBar/>
        </v-container>
        </v-app>
    </div>
</template>

<script>
    import NavBar from '@/components/NavBar'
    import FooterBar from '@/components/FooterBar'
    import Masthead from '@/components/Masthead'

    export default {
        name: 'Photos',
        data () {
            return {
                alignment: 'center',
                dense: false,
                justify: 'center',
            }
        },
        components: {
            NavBar,
            FooterBar,
            Masthead
        }
    }
</script>

<style scoped>
    .backing {
        background-color: #ccc;
    }
    .cards {
        min-height: 250px;
    }
    .container_inner {
        max-width: 1200px;
        background-color: #fff;
    }
    .danPhoto {
        max-width: 250px;
        height: auto;
        margin-top: 2em;
    }
</style>
